module.exports = __webpack_public_path__ + "img/logo-cnpee3.c4c63c2a.svg";